export class VpnRequiredError extends Error {
  constructor() {
    super('This app requires a VPN connection.');
    this.name = 'VpnRequiredError';
  }
}